import 'normalize.css';
import '../scss/main.scss';

import '../images/logo.svg';
import '../images/logo-inverted.svg';
import '../images/logo-white.svg';
import '../images/footer-logo.svg';
import '../images/logo-square.svg';
import '../images/icon-3d-cube.svg';
import '../images/icon-directory.svg';
import '../images/icon-gears.svg';
import '../images/icon-files.svg';
import '../images/icon-stopwatch.svg';
import '../images/icon-envelope.svg';

import WebFont from 'webfontloader';
import VanilleLightbox from 'vanillelightbox';
import CarouselSlider from './carousel-slider';
import ScrollClasses from './scrollclasses';
import SideModal from './side-modal';
import MenuCompact from './menu-compact';
import StaffMembers from './staff-members'
import Counter from './counter';
import {createCookie, readCookie, eraseCookie} from './utils';

import ModuleContact from './modules/module-contact';
import ModuleUsp from './modules/module-usp';
import ModuleStaffMembers from './modules/module-staff-members';
import ModuleLogoCarousel from './modules/module-logo-carousel';
import ModuleFaq from './modules/module-faq';
import ArticleItems from './article-items';
import ArticleFilter from './article-filter';

// is here for resizing on font load
const faqModules = [];

WebFont.load({
	active: function() {
		faqModules.forEach(faqModule => {
			faqModule.onResize();
		});
	},
	classes: false,
	google: {
		families: ['Encode+Sans+Expanded:400,500,700,700i', 'Open+Sans:700']
	},
	monotype: {
		projectId: '65c40942-952b-4e1b-b6ab-294762f3f5ce',
		version: 1,
		loadAllFonts: true
	}
});

window.addEventListener('DOMContentLoaded', function() {
	const headerElement = document.getElementById('header-wrapper');
	if (headerElement) {
		new ScrollClasses(
			headerElement,
			[
				{
					'scrolled': 50,
					'class': 'is-scrolled'
				},
			]
		);
	}

	const headerStickyElement = document.getElementById('header-compact-wrapper');
	if (headerStickyElement) {
		new ScrollClasses(
			headerStickyElement,
			[
				{
					'scrolled': 50,
					'class': 'is-scrolled'
				},
			]
		);
	}
});

window.addEventListener('DOMContentLoaded', function() {
	const toTopButton = document.querySelector('.button-to-top');
	if (toTopButton) {
		new ScrollClasses(
			toTopButton,
			[
				{
					'scrolled': 1750,
					'class': 'is-visible'
				}
			]
		);
	}
});


window.addEventListener('DOMContentLoaded', function() {
	const languageMenuButton = document.querySelector('.language-menu-compact-button');

	if (!languageMenuButton) {
		return;
	}

	const languageMenuWrapper = document.querySelector('.language-menu-compact-container-wrapper');
	const languageMenuContainer = document.querySelector('.language-menu-compact-container');

	languageMenuButton.addEventListener('click', function() {
		languageMenuWrapper.classList.toggle('is-open');
		languageMenuButton.classList.toggle('is-open');
	});

	if (languageMenuWrapper.classList.contains('header-language-menu-type-modal')) {
		languageMenuWrapper.addEventListener('click', function(event) {
			if(event.target === languageMenuWrapper) {
				this.classList.remove('is-active');
			}
		});
	}
	else {
		window.addEventListener('click', function(event) {
			if (!languageMenuWrapper.contains(event.target) && event.target !== languageMenuButton) {
				languageMenuWrapper.classList.remove('is-active');
			}
		});
	}
});

window.addEventListener('DOMContentLoaded', function() {
	new SideModal(
		document.getElementById('header-compact-navigation-wrapper'),
		document.getElementById('header-compact-navigation-container'),
		{
			activate: document.getElementById('header-compact-menu-button'),
			deactivate: document.getElementById('header-compact-menu-button-deactivate')
		}
	);

	new MenuCompact(document.querySelector('.header-compact-navigation-main-container'));
}, false);

window.addEventListener('DOMContentLoaded', function() {
	let slideContainers = document.querySelectorAll('.slide-wrapper');

	if (slideContainers.length < 1) {
		return;
	}

	slideContainers = [].slice.call(slideContainers);

	slideContainers.forEach(container => {
		const autoplayTimeout = container.getAttribute('data-autoplay-timeout');
		const transitionDuration = container.getAttribute('data-transition-duration');

		let pageDotsContainer = container.querySelector('.slide-pagedots-container');
		pageDotsContainer = pageDotsContainer ? pageDotsContainer : false;

		new CarouselSlider(
			container,
			{
				autoDelay: autoplayTimeout ? parseInt(autoplayTimeout) : 3000,
			},
			container.querySelector('.slide-container'),
			pageDotsContainer
		);
	});
});

/**
 * Init Module USP
 */
window.addEventListener('DOMContentLoaded', function() {
	let glideContainers = document.querySelectorAll('.usp-wrapper.is-use-slider');

	if (glideContainers.length < 1) {
		return;
	}

	glideContainers = [].slice.call(glideContainers);

	glideContainers.forEach(container => {
		new ModuleUsp(container, 1256);
	});
});

/**
 * Init Module Staff Members
 */
window.addEventListener('DOMContentLoaded', function() {
	let glideContainers = document.querySelectorAll('.module-staff-members-wrapper.glide');

	if (glideContainers.length < 1) {
		return;
	}

	glideContainers = [].slice.call(glideContainers);

	glideContainers.forEach(container => {
		new ModuleStaffMembers(container);
	});
});

/**
 * Init Module Logo Carousel
 */
window.addEventListener('DOMContentLoaded', function() {
	let glideContainers = document.querySelectorAll('.logo-carousel-wrapper.glide');

	if (glideContainers.length < 1) {
		return;
	}

	glideContainers = [].slice.call(glideContainers);

	glideContainers.forEach(container => {
		new ModuleLogoCarousel(container);
	});
});

/**
 * Init Module contact
 */
window.addEventListener('load', function() {
	let moduleContactContainers = document.querySelectorAll('.module-contact');

	if (moduleContactContainers.length < 1) {
		return;
	}

	// FIXME: this would fix babel not converting nodelist forEach calls (and update from babel could resolve this also) (IE11)
	moduleContactContainers = [].slice.call(moduleContactContainers);

	moduleContactContainers.forEach(container => {
		const buttonContainer = container.querySelector('.locations-filters-container');
		const contentContainer = container.querySelector('.contact-locations-container');
		const mapsContainers = container.querySelectorAll('.contact-location-map-container');
		new ModuleContact(buttonContainer, contentContainer, mapsContainers);

		const filterContainer = container.querySelector('.locations-filters-container');
		if (!filterContainer) {
			return;
		}

		let buttons = filterContainer.getElementsByTagName('button');
		buttons = [].slice.call(buttons);

		const articleFilter = new ArticleFilter(buttons, false, filterContainer);
		articleFilter.updateFilter();
	});
});

/**
 * Init Module FAQ
 */
window.addEventListener('DOMContentLoaded', function() {
	let moduleFaqContainers = document.querySelectorAll('.module-faq');

	if (moduleFaqContainers.length < 1) {
		return;
	}

	// FIXME: this would fix babel not converting nodelist forEach calls (and update from babel could resolve this also) (IE11)
	moduleFaqContainers = [].slice.call(moduleFaqContainers);

	moduleFaqContainers.forEach(container => {
		faqModules.push( new ModuleFaq(container) );

		const filterContainer = container.querySelector('.faqs-filters-container');

		let buttons = filterContainer.getElementsByTagName('button');
		buttons = [].slice.call(buttons);

		const articleFilter = new ArticleFilter(buttons, false, filterContainer);
		articleFilter.updateFilter();
	});
});

/**
 * Init Articles
 */
window.addEventListener('DOMContentLoaded', function() {
	const articleFilterContainers = document.querySelectorAll('.article-items-filters-container');
	let articleContainers = document.querySelectorAll('.article-items-container');

	if (articleContainers.length < 1) {
		return;
	}

	articleContainers = [].slice.call(articleContainers);

	articleContainers.forEach(container => {
		let articlesId = container.getAttribute('data-articles-id');
		let filterContainer = null;

		if (articlesId) {
			for (let i=0;i<articleFilterContainers.length;i++) {
				if(articleFilterContainers[i].getAttribute('data-articles-id') == articlesId){
					filterContainer = articleFilterContainers[i];
				}
			}
		}

		if( container.classList.contains('reference-items-container') ) {
			initArticles(container, filterContainer, referencesGlobals);
		}
		else {
			initArticles(container, filterContainer, articlesGlobals);
		}

	})

	function initArticles(container, filterContainer, globals) {
		const options = {
			classPrefixItem: 'article-item',
			loadOneTime: 6,
		};

		let types = container.getAttribute('data-articles-types');

		if (types) {
			options.types = types.split(',');
		}

		if (globals.translations) {
			options.strings = globals.translations;
		}

		const articleItems = new ArticleItems(
			container,
			{
				items: globals.xhrItemsUrl
			},
			options
		);

		if (filterContainer) {
			let buttons = filterContainer.getElementsByTagName('button');
			buttons = [].slice.call(buttons);

			const articleFilter = new ArticleFilter(buttons, articleItems.loadItems, filterContainer);
			articleFilter.updateFilter();
		}
	}
});

/**
 * Init Article
 */
window.addEventListener('DOMContentLoaded', function() {
	let lightBoxContainers = document.querySelectorAll('.article-container a[href$=".jpg"], .article-container a[href$=".png"]');

	if (lightBoxContainers.length < 1) {
		return;
	}

	lightBoxContainers = [].slice.call(lightBoxContainers);

	lightBoxContainers.forEach(container => {
		new VanilleLightbox(container);
	});
});

/**
 * Init template Staff Members
 */
window.addEventListener('DOMContentLoaded', function() {
	let filterContainer = document.querySelector('.staff-member-items-filters-container');

	if (filterContainer) {
		let buttons = filterContainer.getElementsByTagName('a');
		buttons = [].slice.call(buttons);

		const articleFilter = new ArticleFilter(buttons, null, filterContainer);
		articleFilter.updateFilter();
	}

	let staffMembers = document.querySelectorAll('.staff-member');

	if (staffMembers.length < 1) {
		return;
	}

	staffMembers = new StaffMembers(staffMembers);
});

/**
 * Init Form Modals
 */
window.addEventListener('DOMContentLoaded', function() {
	let formModalContainers = document.querySelectorAll('.form-modal-wrapper');

	if (formModalContainers.length < 1) {
		return;
	}

	formModalContainers = [].slice.call(formModalContainers);

	formModalContainers.forEach(container => {
		const formId = container.getAttribute('data-form-id');

		const buttons = document.getElementsByClassName('button-form-id-' + formId);

		new SideModal(
			container,
			container.querySelector('.form-modal-container'),
			{
				activate: buttons,
				deactivate: container.querySelector('.form-modal-button-close')
			}
		);
	});
});

window.addEventListener('DOMContentLoaded', function() {
	let counterContainers = document.querySelectorAll('.counter-amount-container');

	if (counterContainers.length < 1) {
		return;
	}

	counterContainers = [].slice.call(counterContainers);

	counterContainers.forEach(container => {
		new Counter(container);
	});
});

window.addEventListener('DOMContentLoaded', function() {
	const buttons = document.querySelectorAll('.article-social-media-share-button');

	for (let i=0;i < buttons.length; i++) {
		buttons[i].addEventListener('click', function(event) {
			if( ! this.href.match(/^http/) ) {
				return;
			}
			event.preventDefault();
			var w = 600;
			var h = 400;
			var left = (screen.width/2)-(w/2);
			var top = (screen.height/3)-(h/2);
			const newwindow = window.open(this.getAttribute('href'),'name', 'toolbar=no, location=no, directories=no, status=no, menubar=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
			if (window.focus) {newwindow.focus()}
		});
	}
});

// modals
window.addEventListener('DOMContentLoaded', function() {
	const modal = document.querySelector('.modal-trigger-container');

	if (!modal) {
		return;
	}

	if(!document.body.classList.contains('logged-in') && readCookie('modal-' + modal.getAttribute('data-modal-id'))) {
		return;
	}

	const triggerValue = modal.getAttribute('data-trigger-value');

	switch (modal.getAttribute('data-trigger-type')) {
		case 'scroll':
			new ScrollClasses(
				modal,
				[
					{
						'scrolled': triggerValue,
						'class': 'is-visible'
					},
				]
			);
			break;
		case 'time':
			setTimeout(function() {
				this.classList.add('is-visible');
			}.bind(modal), triggerValue);
			break;
	}

	const buttonClose = modal.querySelector('.modal-trigger-button-close');

	if (buttonClose) {
		buttonClose.addEventListener('click', function() {
			this.classList.remove('is-visible');
			this.classList.add('is-closed');
			if(!document.body.classList.contains('logged-in')) {
				createCookie('modal-' + this.getAttribute('data-modal-id'), 1, 0);
			}
		}.bind(modal));
	}
});

// General to top buttons
window.addEventListener('DOMContentLoaded', function() {
	let buttons = document.getElementsByClassName('button-to-top');

	if (buttons.length < 1) {
		return;
	}

	buttons = [].slice.call(buttons);

	buttons.forEach(button => {
		button.addEventListener('click', function(){
			document.body.scrollIntoView();
		});
	});
});